import React from 'react';
import MainComponent from './containers/MainComponent/MainComponent';
import './App.css';

function App() {
  return (
    <div className="App">
        <MainComponent />
    </div>
  );
}

export default App;
